import API from '@/api/api-main';

export async function getDataPriceCode() {
    try {
        const [priceCodeResponse, priceCodeTableResponse] = await Promise.all([
            API.get(`PriceCode/GetPriceCode?Filter=isActive=true&Page=1&PageSize=900000`),
            API.get(`PriceCodeTable/getAll?Filter=isActive=true&Page=1&PageSize=900000`)
        ]);
        return { priceCodes: priceCodeResponse.data.priceCodes, priceCodeTable: priceCodeTableResponse.data.items };

    } catch (error) {
        return [];
    }
}

export async function getDataGoldCodeTable() {
    try {
        const { data } = await API.get(`GoldCodeTable/getall?Page=1&PageSize=900000`);
        return data?.item || [];
    } catch (error) {
        return [];
    }
}
export async function getDataExchangeRate() {
    try {
        const { data } = await API.get(`DailyGoldRate/getall?Filter=(isActive=true)`);
        if (data?.items?.length > 0) {
            return data?.items[0]?.goldRate || 0;
        }
        return 0;
    } catch (error) {
        return [];
    }
}
